/**
 * Build-time configuration for date formats
 * This file provides a safe way to set default formats without runtime environment variable access
 */

import { DateFormatConfig } from './dateFormats';

// Manual configuration - change this value to set different defaults for different builds
// This avoids runtime environment variable access issues
const BUILD_TIME_DEFAULT: DateFormatConfig = 'default';

// For different environments, you can modify this file or create environment-specific versions:
// - buildTimeConfig.production.ts with 'us' format
// - buildTimeConfig.development.ts with 'default' format
// - etc.

export const getBuildTimeDefaultFormat = (): DateFormatConfig => {
  return BUILD_TIME_DEFAULT;
};

// Helper function to validate the configured format
export const isValidDateFormatConfig = (config: string): config is DateFormatConfig => {
  return ['default', 'us', 'iso', 'custom'].includes(config);
};
